module.exports = __webpack_public_path__ + "img/benoit17.3d9b2f5e.jpg";